/**
 * Filter zero values
 * @param  {Number} value The value to Filter
 * @return {Boolean} true if value is zero, false otherwise
 */
export default function (value) {
  return value === 0;
}
